import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react';

if(['production', 'staging'].includes(import.meta.env.VITE_ENV)) {
  Bugsnag.start({
    apiKey: 'ffe6caa64aecada6e5106886e5cf1e2c',
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: import.meta.env.VITE_ENV || 'development',
  });
}
